import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { Transition } from '@uirouter/angular';
import { FormsComponent } from './forms.component';
import { FormsDataService } from './forms-data.service';
import { FormsService } from './forms.service';
import { FormsContainerComponent } from './forms-container.component';
import { CustomComponentService } from './custom-component.service';
import { TestComponent } from './components/test.component';
import { FormsHelpComponent } from './forms-help.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { GaStateDeclaration } from '../../../type_definitions/datatypes';

const states:GaStateDeclaration[] = [
  {
    name: 'main.forms',
    url: '/forms/:formId?key',
    views: {
      content: {
        component: FormsComponent
      }
    },
    resolve: [
      {
        token: 'formId',
        deps: [Transition],
        resolveFn: (transition: Transition) => transition.params().formId
      },
      {
        token: 'key',
        deps: [Transition],
        resolveFn: (transition: Transition) => transition.params().key
      }
    ]
  }
];

@NgModule({
  declarations: [
    FormsComponent,
    FormsContainerComponent,
    FormsHelpComponent,
    TestComponent
  ],
  imports: [
    UIRouterModule.forChild({ states }),
    CommonModule,
    PopoverModule,
    SharedModule
  ],
  providers: [
    FormsDataService,
    FormsService,
    CustomComponentService
  ]
})
export class FormsModule {
}